import { Injectable } from '@angular/core';
import { appService } from '../../../_services/app.service';
import { CommonService } from '../commen/commen.services';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { Helpers } from '../../../helpers';
import {
    Http,
    Headers,
    RequestOptions,
    Response,
    ResponseContentType
} from '@angular/http';
import { environment } from '../../../../environments/environment';

@Injectable()
export class ManifestService {

  constructor(
    private _appService: appService,
    private commonService: CommonService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private anghttp: Http,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe
  ) { }

  async getOutwardInvoicePrintHTML(printReportChild: any,companyId: any,userId: any,orderId: any,deliveryPartner: any,trackingNumber: any,orderNo: any,city: any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if (trackingNumber && trackingNumber.toString().trim() !== '') {
        this.toastr.warning('Order has already been manifested.','Warning');
        reject();
        return;
      }

      if (!deliveryPartner) {
          this.toastr.warning('Please select a delivery partner before manifesting the order.','Warning');
          reject();
          return;
      }

      Helpers.setLoading(true);

      printReportChild.divElements = null;
      printReportChild.CompanyId = companyId;
      printReportChild.OrderId = orderId;
      printReportChild.ParentUserId = userId;
      printReportChild.isInvoiceOnlyHtmlView = true;
      printReportChild.ReportType = 'Print Goods Outward Invoice';

      await new Promise<void>((done) => {

          const sub = printReportChild.renderComplete.subscribe(() => {
            done();
            sub.unsubscribe();
          });

          printReportChild.PrintInvoice();
      });

      const reportHtml = printReportChild.divElements;
      Helpers.setLoading(false);

      this.SaveInvoicePdf(reportHtml,orderNo,orderId,deliveryPartner,trackingNumber,city,userId).then(() => {
        resolve(true);
      }).catch(err => {
        reject(err);
      });

    });
  }

  SaveInvoicePdf(htmlData: string,orderNo: any,orderId: any,deliveryPartner: any,trackingNumber: any,city: any,userId: any): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!htmlData) {
        this.toastr.error('Invoice HTML data is empty.','Error');
        Helpers.setLoading(false);
        reject();
        return;
      }
      const invoiceNo = String(orderNo).replace(/[^a-zA-Z0-9]/g, '');
      const fileName ='GoodsOutwardInvoice' + invoiceNo + '.pdf';

      const payload = {
        HtmlData: htmlData,
        FileName: fileName
      };

      const headers = new Headers();
      const token = this.decryptpipe.transform(JSON.parse(this.cookieService.get('user_access_token')));
      headers.append('Authorization','Bearer ' + token);

      const options = new RequestOptions({
        headers,
        responseType: ResponseContentType.Blob
      });

      const apiUrl = environment.apiUrl + '/api/OrdersByVehicle/GenerateOutwardInvoicePdf';

      this.anghttp.post(apiUrl, payload, options).subscribe(
        (response: Response) => {
          const pdfBlob = response.blob();

          if (!pdfBlob || pdfBlob.size === 0) {
            this.toastr.error('Generated PDF is empty.','Error');
            Helpers.setLoading(false);
            reject();
            return;
          }

          const pdfFile = new File(
              [pdfBlob],
              fileName,
              {
                type: 'application/pdf',
                lastModified: new Date().getTime()
              }
          );

          this.UploadDocument(pdfFile,orderId,deliveryPartner,trackingNumber,city,userId,fileName).then(() => {
            resolve(true);
          }).catch(err => {
            reject(err);
          });
        },

        err => {
          console.error(err);
          this.toastr.error('Unable to generate invoice PDF.','Error');
          Helpers.setLoading(false);
          reject(err);
        }
      );
    });
  }

  UploadDocument(selectedFile: File,orderId: any,deliveryPartner: any,trackingNumber: any,city: any,userId: any,fileName:any): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!selectedFile) {
        this.toastr.error(this.translate.instant('Attachment.UploadFileError'),'Error');
        Helpers.setLoading(false);
        reject();
        return;
      }

      const { formData, options } = this.commonService.setHeaderAndOptionsForFileUpload(selectedFile);
        
      const apiUrl =
          environment.apiUrl +
          '/api/Document/UploadAttachment?ReferenceId=' +
          orderId +
          '&TransectionType=Good Outward&ParentId=';

      this.anghttp.post(apiUrl, formData, options).subscribe(
        (response: any) => {
          // this.GetAddressDetailsByCity(city,orderId,userId).then(() => {
          //   return this.manifestOrderWithDeliveryPartner(
          //     orderId,
          //     deliveryPartner,
          //     trackingNumber
          //   );

          // }).then(() => {
          //   Helpers.setLoading(false);
          //   resolve(true);
          // }).catch(err => {
          //   Helpers.setLoading(false);
          //   reject(err);
          // });
          
          this.DeleteOldGoodsOutwardInvoice(orderId,fileName,userId).catch(() => {});
          this.GetAddressDetailsByCity(city, orderId, userId).catch(() => {});
          this.manifestOrderWithDeliveryPartner(orderId,deliveryPartner,trackingNumber).then(() => {
            Helpers.setLoading(false);
            resolve(true);
          }).catch(err => {
            Helpers.setLoading(false);
            reject(err);
          });
        },

        err => {
          console.log(err);
          this.toastr.error(this.translate.instant("Attachment.UploadError"),"Error");
          Helpers.setLoading(false);
          reject(err);
        }
      );
    });
  }

  GetAddressDetailsByCity(city: any,orderId: any,userId: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const payload = {
        City: city,
        OrderId: orderId,
        UserId: userId
      };

      this._appService.Post('OrdersByVehicle','GetAddressDetailsByCity',payload).subscribe(
        res => {
          console.log(res);
          resolve(res);
        },
        err => {
          let errorMsg = '';
          if (err && err._body) {
              errorMsg = err._body.replace(/"/g, '');
          } else if (err && err.message) {
              errorMsg =err.message;
          } else {
              errorMsg = 'Something went wrong while manifesting the order.';
          }
          
          this.toastr.error(errorMsg,'Error');
          Helpers.setLoading(false);
          reject(err);
        }
      );
    });
  }

  manifestOrderWithDeliveryPartner(orderId: any,deliveryPartner: any,trackingNumber: any): Promise<any> {
    return new Promise((resolve, reject) => {
      if (trackingNumber && trackingNumber.toString().trim() !== '' ) {
        this.toastr.warning('Order has already been manifested.','Warning');
        reject();
        return;
      }

      if (!deliveryPartner) {
        this.toastr.warning('Please select a delivery partner before manifesting the order.','Warning');
        reject();
        return;
      }

      Helpers.setLoading(true);
      this._appService.GetByTwoParam('OrdersByVehicle','ExecuteDynamicApi',orderId,deliveryPartner).subscribe(
        response => {
          Helpers.setLoading(false);

          if (!response) {
            resolve(true);
            return;
          }

          let res = '';
          if (typeof response === 'string') {
              res = response;
          } else {
              res = JSON.stringify(response);
          }

          const lowerRes = res.toLowerCase();

          const isWarning =
              lowerRes.indexOf('"alerts"') >= 0 ||
              lowerRes.indexOf('"alerttype":"warning"') >= 0 ||
              lowerRes.indexOf('"alerttype": "warning"') >= 0;

          const isError =
              lowerRes.indexOf('api failed') >= 0 ||
              lowerRes.indexOf('system.exception') >= 0 ||
              lowerRes.indexOf('"error"') >= 0 ||
              lowerRes.indexOf('"errors"') >= 0 ||
              lowerRes.indexOf('invalidinput') >= 0 ||
              lowerRes.indexOf('invalid input') >= 0 ||
              lowerRes.indexOf('missing') >= 0 ||
              lowerRes.indexOf('failed') >= 0;

          if (isError) {
            this.toastr.error(res,'Error');
            reject(res);
            return;
          }

          if (isWarning) {
            this.toastr.warning(res,'Warning');
            reject(res);
            return;
          }
          this.toastr.success('Manifestation completed successfully','Success');
          resolve(response);
        },

        err => {
          Helpers.setLoading(false);

          let errorMsg = '';
          if (err && err._body) {
            errorMsg = err._body.replace(/"/g, '');
          } else if (err && err.message) {
            errorMsg = err.message;
          } else {
            errorMsg = 'Something went wrong while manifesting the order.';
          }

          this.toastr.error(errorMsg,'Error');
          reject(err);
        }
      );
    });
  }

  DeleteOldGoodsOutwardInvoice(orderId: any,OrderNo: any,userId: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const payload = {
        ReferenceId: orderId,
        FileName: OrderNo,
        UserId: userId
      };

      this._appService.Post('OrdersByVehicle','DeleteOldGoodsOutwardInvoice',payload).subscribe(
        res => {
          console.log(res);
          resolve(res);
        },
        err => {
          let errorMsg = '';
          if (err && err._body) {
              errorMsg = err._body.replace(/"/g, '');
          } else if (err && err.message) {
              errorMsg =err.message;
          } else {
              errorMsg = 'Something went wrong.';
          }
          
          this.toastr.error(errorMsg,'Error');
          Helpers.setLoading(false);
          reject(err);
        }
      );
    });
  }
}